import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueApexCharts from "vue3-apexcharts";
import mitt from "mitt";
import store from "./store"; // Import Vuex store directly
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

// Import custom styles
import "./assets/scss/font.scss";

// Create the Vue 3 app instance
const app = createApp(App);

// Use Vuex store
app.use(store);

// Use router and Vuetify
app.use(router);
app.use(vuetify);
app.use(VueApexCharts);
app.use(VueVirtualScroller);

// Register global components
app.component("apexchart", VueApexCharts);

// Create a global event bus using mitt (replacement for Vue 2 event bus)
const emitter = mitt();
app.config.globalProperties.$eventBus = emitter;

// Global error handler to suppress ResizeObserver errors
const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(null, args), delay);
  };
};

const resizeObserverErrorHandler = debounce((error) => {
  if (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    return;
  }
  console.error('Unhandled error:', error);
}, 0);

window.addEventListener('error', resizeObserverErrorHandler);
window.addEventListener('unhandledrejection', resizeObserverErrorHandler);

// Mount the app
app.mount("#app");
